module.exports = __webpack_public_path__ + "img/selgem-logo.cfc970a9.png";